import { ExportOutlined } from '@ant-design/icons';

interface CourseNameLinkProps {
  href?: string;
  name?: string;
}

export const CourseNameLink = ({ href, name }: CourseNameLinkProps) => {
  if (!href || !name) {
    return <span>{name || '-'}</span>;
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="group inline-flex items-center gap-1 text-inherit hover:text-inherit"
    >
      <span>{name}</span>
      <ExportOutlined className="course-link-icon text-xs opacity-0 transition-opacity group-hover:opacity-100" />
    </a>
  );
};
